export { default as ViewComps } from './ViewComps';
export { default as ViewTheatres } from './ViewTheatres';
export { default as ViewTransition } from './ViewTransition';
export { default as BackArrow } from './BackArrow';
export { default as PosterBg } from './PosterBg';
